import React from 'react';
import { gql } from '@urql/core';
import { ConversationCardFragment, Espin_Role_Enum } from '../../../generated/spin-graphql';
import { CollegeConversationCard } from './colleges/CollegeConversationCard';
import { PlayerConversationCard } from './players/PlayerConversationCard';
import { useAppState } from '../../../client/providers/AppProvider';

type Props = {
    lastMessage?: ConversationCardFragment;
    selected?: boolean;
    isFake: boolean;
    index: number;
};

gql`
    fragment ConversationCard on espin_message {
        ...PlayerConversationCard
        ...CollegeConversationCard
    }
`;

export const ConversationCardContainer: React.FC<Props> = ({ lastMessage, selected, isFake, index }) => {
    const { user } = useAppState();

    return (
        <>
            {user?.role === Espin_Role_Enum.EspinCollegeUser && (
                <CollegeConversationCard conversation={lastMessage} selected={selected} isFake={isFake} index={index} />
            )}
            {(user?.role === Espin_Role_Enum.EspinParentUser ||
                user?.role === Espin_Role_Enum.EspinPlayerUser ||
                user?.role === Espin_Role_Enum.EspinHighschoolUser) && (
                <PlayerConversationCard conversation={lastMessage} selected={selected} isFake={isFake} index={index} />
            )}
        </>
    );
};
